<template>
    <div class="organization-integration__view">
        <div v-if="hasAzureADLicence" class="form">
            <v-form
                ref="form"
                v-model="valid"
                lazy-validation
            >
                <v-layout>
                    <v-flex xs12>
                        <v-layout row>
                            <v-flex md12>
                                <div class="content-wrapper">
                                    <div class="info-block">
                                        Azure AD Integration
                                    </div>
                                </div>
                            </v-flex>
                        </v-layout>
                        <v-layout row v-if="errors !== null">
                            <v-flex md12>
                                <div class="content-wrapper">
                                    <div class="error-block">
                                        <div class="title">Errors</div>
                                        <p v-html="errors"></p>
                                    </div>
                                </div>
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex md6>
                                <div class="content-wrapper">
                                    <v-layout row>
                                        <v-flex xs4>
                                            <div class="label text-xs-right">
                                                <span class="text-xs-right">Azure AD Tenant Id<span class="required">*</span></span>
                                            </div>
                                        </v-flex>
                                        <v-flex xs8>
                                            <v-text-field
                                                label="Insert Azure AD Tenant Id"
                                                v-model="form.azureADTenantId"
                                                :rules="rules.azureADTenantId"
                                                required
                                                outline
                                                single-line
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                </div>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
                <v-layout row class="buttons">
                    <v-flex xs6>
                    </v-flex>
                    <v-flex xs6 class="right text-xs-right">
                        <div class="content-wrapper">
                            <sp-button @click.native="validate" text="Save" icon="download" class="icon"></sp-button>
                        </div>
                    </v-flex>
                </v-layout>
            </v-form>
        </div>
        <div v-if="!hasAzureADLicence && !initialLoading" class="organization-integration__info-wrapper">
            <h4 class="organization-integration__info">
                There are no integrations enabled for given organization
            </h4>
        </div>
        <sp-loader v-if="isLoading || initialLoading"></sp-loader>
    </div>
</template>

<script>

import toast from '@/plugins/izitoast'
import OrganizationSettingsApi from '@/api/OrganizationsSettingsApi'
import OrganizationApi from '@/api/OrganizationApi'
import { mapGetters } from 'vuex'
import SpLoader from '@/components/atoms/Loader'

import SpButton from '@/components/forms/Button'

const organizationSettingsApi = new OrganizationSettingsApi()
const organizationApi = new OrganizationApi()

export default {
    name: 'OrganizationIntegrationsDetails',
    async mounted () {
        this.uuid = this.$route.params.organizationUuid
        this.initialLoading = true
        await Promise.allSettled([
            this.getOrganizationIntegrationSettings(),
            this.getOrganization()
        ])
        this.initialLoading = false
    },
    components: {
        SpButton,
        SpLoader
    },
    data () {
        return {
            isLoading: false,
            initialLoading: false,
            hasAzureADLicence: false,
            azureIdLicenseId: this.mixinGetAzureADLicenseId(),
            uuid: null,
            valid: false,
            errors: null,
            form: {
                azureADTenantId: ''
            },
            rules: {
                azureADTenantId: [
                    v => (v === (v || '').trim()) || 'Azure AD Tenant Id cannot have leading or trailing spaces'
                ]
            }
        }
    },
    computed: {
        ...mapGetters({
            getLicenses: 'dictionaryModule/getLicenses'
        })
    },
    methods: {
        async getOrganizationIntegrationSettings () {
            this.isLoading = true
            const response = await organizationSettingsApi.getOrganizationIntegrationSettings(this.uuid)

            if (!response.isSuccess) return

            this.form.azureADTenantId = response.payload.azureADTenantId

            this.isLoading = false
        },
        async getOrganization () {
            this.isLoading = true
            const response = await organizationApi.getOrganizationById(this.uuid)

            if (response.isSuccess && Array.isArray(response.payload.licenses)) {
                this.hasAzureADLicence = response.payload.licenses.some(license => license.id === this.azureIdLicenseId)
            }

            this.isLoading = false
        },
        async editOrganizationIntegrationSettings (form) {
            this.isLoading = true
            const response = await organizationSettingsApi.editOrganizationIntegrationSettings({
                organizationId: this.uuid,
                azureADTenantId: form.azureADTenantId
            })
            if (!response.isSuccess) {
                this.isLoading = false
                return
            }

            this.isLoading = false
            toast.success('Organization integration settings successfully updated.')
        },
        async validate () {
            this.valid = this.$refs.form.validate()
            if (!this.valid) {
                return false
            }

            try {
                this.errors = null
                await this.editOrganizationIntegrationSettings(this.form)
            } catch (e) {
                this.errors = e.message
            }
        }
    }
}
</script>

<style scoped lang="scss">
.organization-integration__view {
    width: 100%;
}

.organization-integration__info-wrapper {
    min-height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.organization-integration__info {
    text-align: center;
    font-size: 18px;
}
</style>
